module.exports = __webpack_public_path__ + "static/v3-cf98ad1ab7970f1f650637af1999fdd3.jpg";